// 512 short, common, unambiguous English words for passphrases (9 bits each).
// Starts with the prototype's list so the examples in the design still read
// the same.
export const WORDS: readonly string[] = `
ridge copper lantern orbit fjord maple cobalt harbour quartz tundra meadow signal
pebble vector canyon ember willow atlas marble nimbus beacon thistle granite falcon
acorn admiral almond amber anchor angle apple apron arch arrow aspen autumn
badger bagel bakery bamboo banjo barley barn basil basket beach beaver bell
bench berry birch biscuit bison blanket blossom boat bonnet border bottle boulder
bracket branch brass bread breeze brick bridge brook broom bubble bucket budget
buffalo bundle burrow butter button cabin cable cactus camel camera candle canoe
canvas carbon carpet carrot castle cedar cellar cement cereal chalk channel chapel
cherry chess chimney cider cinema circle citrus clay cliff clock cloud clover
coast cobble cocoa comet compass concert coral cotton cradle crane crater crayon
cricket crown crystal cupboard curtain cushion cycle daisy dancer delta desert
diamond dinner dolphin donkey dragon drawer dune eagle easel echo elbow elder
engine falcon fabric feather fern ferry fiddle field fiesta filter finch flannel
flute forest fossil fountain fox frost galaxy garden garlic gate gecko geyser
ginger glacier globe goose gravel grove guitar gull hammer hamlet harp hazel
heron hickory hollow honey horizon hornet iceberg igloo island ivory jacket
jasmine jelly jetty jigsaw jungle kayak kernel kettle kitten kiwi koala ladder
lagoon lake lemon lentil library lilac linen lizard lobster locket lotus lunar
magnet mango mantle maple marsh meadow melon mercury meteor mint mirror mitten
monsoon moose mosaic moss mountain muffin mural nectar needle nettle noodle
nugget oak oasis ocean olive onion opal orange orchard orchid otter owl oyster
paddle palace panda paper parrot pasta peach peanut pear pepper piano pickle
pigeon pillow pine planet plum pocket polar pond poppy porch potato prairie prism
pumpkin puzzle quail quarry quill quilt rabbit radar radish rain raven reef
ribbon river robin rocket rose rowan ruby saddle saffron salmon sandal satin
saucer scarf school scooter season shadow shell shore silver sketch sled slipper
snail sonnet sparrow spice spider spiral sponge spruce squash stable starling
statue stone storm straw stream summit sunset swan sweater table tablet tapestry
teapot temple thunder tiger timber toast tomato topaz torch tortoise tower
tractor trail tram tulip tunnel turnip turtle umbrella valley velvet violin
volcano voyage wagon walnut walrus wander water wave weasel wheat whisker whistle
window winter wizard wombat wool yacht yarrow yogurt zebra zephyr zinc
abbey alcove alpine amulet arcade arena attic avenue bagpipe ballad banner
barrel beetle blender bonfire bramble bristle buckle bungalow cactus caramel
cashew cavern chariot chestnut chorus clarinet cobweb coconut cottage crumpet
custard dagger dewdrop dingo domino doodle dragonfly driftwood duvet emerald
fable fennel ferret fig firefly flamingo fudge gadget gazebo gherkin glove
goblet gondola gorilla grape griddle hedgehog helmet hermit hiker hopscotch
icicle inkwell jackal jam jewel juniper kestrel kingfisher lark lava lemonade
lichen lighthouse llama loom lynx macaw mammoth marigold marmalade meerkat
minnow mole muesli mustard narwhal nutmeg ocelot omelette orbit origami osprey
pancake panther papaya parsnip pebble pelican penguin petal pheasant pinecone
plover poncho porridge pretzel puffin quiver raccoon raisin rapids rhubarb
riddle saucepan scone seagull sequin shamrock sherbet shrimp skylark sorbet
spinach squirrel stallion strudel sundial tadpole tangerine teacup thimble
toffee toucan trellis trumpet truffle tugboat vanilla viper waffle warbler
`
  .split(/\s+/)
  .filter((w, i, all) => w && all.indexOf(w) === i)
  .slice(0, 512);
